<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      ref="table"
      row-id="sampleBarcode"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      :radio-config="{ highlight: true }"
      :checkbox-config="{
        highlight: true,
        reserve: true
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayName="{ row }">
        <span>{{ row.sampleName }}</span>
        <br />
        <span>{{ row.sampleNameEn }}</span>
      </template>
      <template v-slot:specInfo="{ row }">
        {{ row.sampleSpec }} {{ row.v_sampleSizeUnit }}
      </template>
      <template v-slot:weightInfo="{ row }">
        {{ row.sampleWeight }} {{ row.v_sampleWeightUnit }}
      </template>
      <template v-slot:moqInfo="{ row }">
        {{ row.moq }} {{ row.v_moqUnit }}
      </template>
      <template v-slot:quotedPriceInfo="{ row }">
        {{ row.quotedPrice }} {{ row.v_quotedCurrency }}
      </template>
      <template v-slot:costPriceInfo="{ row }">
        {{ row.costPrice }} {{ row.v_costCurrency }}
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { default: null, type: Object },
    loading: { type: Boolean, default: false },
    type: String
  },
  data() {
    return {
      tableHeight: 600,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        }
      },
      tableColumns: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
          visible: this.type === 'checkbox'
        },
        {
          field: 'radio',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'radio',
          visible: this.type === 'radio'
        },
        {
          field: 'defaultImageUrl',
          width: 120,
          title: this.$l('INDEX.table_label_image') || '图片',
          align: 'center',
          fixed: 'left',
          slots: { default: 'defaultImageUrl' }
        },
        {
          title: this.$l('INDEX.stock_form_sample_no') || '样品款号',
          field: 'sampleStyleNo',
          minWidth: 160,
          headerAlign: 'left',
          align: 'left',
          fixed: 'left',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.stock_form_sample_barcode') || '样品条码',
          field: 'sampleBarcode',
          minWidth: 160,
          fixed: 'left',
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.stock_form_sample_name') || '样品名称',
          field: 'sampleName',
          minWidth: 350,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          // showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.stock_form_qty') || '库存数量',
          field: 'invNum',
          minWidth: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.stock_form_location_no') || '存放库位',
          field: 'locationNo',
          minWidth: 150,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.stock_form_location_desc') || '库位说明',
          field: 'locationDescription',
          minWidth: 170,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.stock_form_change_time') || '变动时间',
          field: 'modifyDate',
          minWidth: 170,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.stock_form_change_desc') || '变动说明',
          field: 'modifyDescription',
          minWidth: 170,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.stock_form_change_bill_no') || '业务单号',
          field: 'modifyBillNo',
          minWidth: 170,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        }
      ]
    }
  },
  methods: {
    choiceData() {
      if (this.type === 'checkbox') {
        return this.getCheckboxRecords()
      }
      if (this.type === 'radio') {
        return this.getRadioRecord()
      }
    },
    getRadioRecord() {
      const data = this.$refs.table.getRadioRecord()
      if (!data) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning'
        })
        return
      }
      return data
    },
    getCheckboxRecords() {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
      if (!data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning'
        })
        return
      }
      return data
    }
  }
}
</script>
